import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { ProfileForm } from '#admin/features/account/profile-form.tsx'
import { ProfileSkeleton } from '#admin/features/account/profile-skeleton.tsx'
import { profileQuery } from '#admin/features/account/queries.ts'

/** `/account`: the signed-in person's own profile. Opened from the account menu, not the sidebar. */
export const Route = createFileRoute('/_authenticated/account')({
  pendingComponent: ProfileSkeleton,
  staticData: { crumb: 'Profile' },
  loader: ({ context }) => context.queryClient.ensureQueryData(profileQuery()),
  component: AccountPage,
})

function AccountPage() {
  const { data } = useSuspenseQuery(profileQuery())

  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-xl font-semibold">Profile</h1>
        <p className="text-sm text-muted-foreground">
          Your name and contact details. They show in every event you take part in.
        </p>
      </header>

      <ProfileForm initial={data} />
    </div>
  )
}
